module.exports = __webpack_public_path__ + "img/cn_pocket-5.8c84a68.jpg";